import api from '@/apis/di/departmentAPI.js';
import CrudCache from '@/stores/crudBaseCache.js';
var crud = new CrudCache('department', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_department',
    defaultSort: 'misa_code_id',
    field: {
      key: 'department_id',
      code: 'department_code',
      name: 'department_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
